var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 905,
    height: 905,
    viewBox: "0 0 905 905",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 82,
    width: 741,
    height: 741,
    rx: 100,
    fill: "#3B82F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 905,
    height: 905,
    rx: 160,
    fill: "#3B82F6",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M485.666 384.667H553L485.666 317.333V384.667ZM334.166 603.5V527.75H569.833V603.5H334.166ZM276.546 494.083V477.25H627.454V494.083H276.546ZM334.166 443.583V300.5H494.083L569.833 376.25V443.583H334.166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScans);
export default __webpack_public_path__ + "static/media/scans.829779fea8b5e7ad110bd851e844a523.svg";
export { ForwardRef as ReactComponent };